<template>
  <div class="container">
    <div class="box--title">
      <div>
        <h1 class="title" id="Recommended">{{ slug }}</h1>

        <div class="sub-title">
          <img
            src="/img/popcorn.png"
            alt="How Many Have You Seen?"
            height="50px"
          />
          <span class="">How Many Have You Seen?</span>
        </div>
      </div>
      <div class="circle-bar">
        <ith-recommended-circle-bar />
      </div>
    </div>
    <ith-recommended-grid-detail />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["items_user"]),
  data: () => ({
    movies: true,
    slug: "",
  }),

  created() {
    const searchRegExp = /-/g;
    const replaceWith = " ";
    this.slug = this.$route.params.slug.replace(searchRegExp, replaceWith);
  },
};
</script>

<style scoped>
.container {
  position: relative;
  display: grid;
}
.box--title {
  display: grid;
  grid-template-rows: 150px;
  grid-template-columns: 70% auto;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.circle-bar {
  margin-top: 30px;
  justify-items: end;
}

.btn--filter {
  padding-top: 25px;
  justify-self: center;
}

.btn--filter > span {
  margin: 10px;
  cursor: pointer;
}

.active {
  background-color: #94c659;
  padding: 7px 20px;
  border-radius: 30px;
}
h1 {
  margin: 0px;
}
.title {
  font-size: 35px;
  font-weight: 600;
  padding-bottom: 20px;
  align-self: start;
}
.sub-title {
  margin: 15px 20px;
}
.sub-title > span {
  font-size: 30px;
  font-family: "Alegreya SC", serif;
  margin-left: 20px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .title {
    margin: 0px 10px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.9em;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .title {
    margin: 0px 10px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.9em;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }

  .title {
    margin: 0px 10px;
    font-size: 35px;
  }
  .btn--filter {
    padding-top: 100px;
    font-size: 0.8em;
  }
}

@media (max-width: 600px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .btn--filter > span {
    font-size: 0.8em;
  }
  .btn--filter {
    display: flex;
    text-align: center;
  }
  .sub-title > span {
    font-size: 20px;
  }
}
</style>
